import { useContext } from 'react'

import { ThemeMode } from '../context'

export function useThemeMode() {
  return useContext(ThemeMode)
}
